var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        width: "560px",
        "show-close": false,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.innerVisible = $event
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c(
        "div",
        { staticClass: "fd-head", attrs: { slot: "title" }, slot: "title" },
        [
          _c("div", { staticClass: "fd-ico" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                },
              },
              [
                _c("path", {
                  attrs: { d: "M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" },
                }),
                _c("path", { attrs: { d: "M13.7 21a2 2 0 0 1-3.4 0" } }),
              ]
            ),
          ]),
          _c("div", { staticClass: "fd-title" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.isAdd ? "新增告警接收人" : "编辑接收人")),
            ]),
            _c("span", { staticClass: "fd-pt" }, [
              _vm._v(
                _vm._s(
                  _vm.isAdd
                    ? "Novo Destinatário de Alerta"
                    : "Editar Destinatário"
                )
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-position": "top",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "name" } },
            [
              _c(
                "template",
                { slot: "label" },
                [
                  _c("bi-label", {
                    attrs: {
                      zh: "接收群名称",
                      pt: "Nome do Grupo",
                      inline: "",
                    },
                  }),
                ],
                1
              ),
              _c("el-input", {
                attrs: {
                  placeholder:
                    "例如：税务开票风险预警群 / Ex.: Grupo de Risco Fiscal",
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            2
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "webhookUrl" } },
            [
              _c(
                "template",
                { slot: "label" },
                [
                  _c("bi-label", {
                    attrs: {
                      zh: "机器人 Webhook",
                      pt: "Webhook do Bot",
                      inline: "",
                    },
                  }),
                ],
                1
              ),
              _c("el-input", {
                attrs: {
                  placeholder: _vm.isAdd
                    ? "https://open.feishu.cn/..."
                    : "留空保持原值 / Deixe vazio para manter o valor atual",
                },
                model: {
                  value: _vm.form.webhookUrl,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "webhookUrl", $$v)
                  },
                  expression: "form.webhookUrl",
                },
              }),
              !_vm.isAdd
                ? _c("div", { staticClass: "hint" }, [
                    _vm._v(
                      " 编辑时留空表示保持原 webhook 不变 / Em edição, deixe vazio para manter o webhook atual "
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-form-item",
            [
              _c(
                "template",
                { slot: "label" },
                [
                  _c("bi-label", {
                    attrs: {
                      zh: "订阅类型",
                      pt: "Tipos Assinados",
                      inline: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-checkbox-group",
                {
                  staticClass: "subs-group",
                  model: {
                    value: _vm.form.subs,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "subs", $$v)
                    },
                    expression: "form.subs",
                  },
                },
                _vm._l(_vm.alertTypes, function (t) {
                  return _c(
                    "el-checkbox",
                    { key: t.value, attrs: { label: t.value } },
                    [
                      _c("span", [_vm._v(_vm._s(t.zh))]),
                      _c("span", { staticClass: "sub-pt" }, [
                        _vm._v("/ " + _vm._s(t.pt)),
                      ]),
                    ]
                  )
                }),
                1
              ),
              _c("div", { staticClass: "hint" }, [
                _vm._v(
                  " 不勾选表示订阅全部告警类型 / Sem seleção = assina todos os tipos de alerta "
                ),
              ]),
            ],
            2
          ),
          _c(
            "el-form-item",
            [
              _c(
                "template",
                { slot: "label" },
                [
                  _c("bi-label", {
                    attrs: { zh: "启用", pt: "Ativação", inline: "" },
                  }),
                ],
                1
              ),
              _c("el-switch", {
                model: {
                  value: _vm.form.enable,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "enable", $$v)
                  },
                  expression: "form.enable",
                },
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fd-footer", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.innerVisible = false
                },
              },
            },
            [
              _c("bi-label", {
                attrs: { zh: "取消", pt: "Cancelar", inline: "" },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.handleSave },
            },
            [
              _c("bi-label", {
                attrs: { zh: "保存", pt: "Salvar", inline: "" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }